export const getPaymentMode = (paymentMode: string) => {    
    if(paymentMode === 'UPI'){
        return "Upi";
    }
    else if(paymentMode === 'NETBANKING'){
        return "Net banking"
    }
    else if(paymentMode === 'CARD'){
        return 'Card';
    }
    else return paymentMode;
}

export enum REPAYMENT_COLLECTION_TYPE {
    FORECLOSURE = 'FORECLOSURE',
    LOAN_EXPIRED_DUE_REPAYMENT = 'LOAN_EXPIRED_DUE_REPAYMENT',
    PRINCIPAL_REPAYMENT = 'PRINCIPAL_REPAYMENT',
    IN_APP_INTEREST_COLLECTION = 'IN_APP_INTEREST_COLLECTION',
    SHORTFALL_REPAYMENT = 'SHORTFALL_REPAYMENT'
}